
// DIVIDE TEXT OF NOTE ON PARAGRAPH

const divideText = (text) => {
    if (text) {

    const array1 = text.split(/([\#])/g); // divide string on part with #, in the each! part of string need #
    //console.log(array1);

   //delete points
    const array2 = array1.filter(e=>{
       // console.log(e);
       return e!=='#'
    }
        );
    //console.log(array2);
    //delete last element if length array >1
    let array3;
    let array4;
     if (array2.length===1) {
         array3 = array2;
    } else {
         array3 = array2.slice(0,-1);
    }
      
    // console.log(array3);
     array4 = array3;
    return (
        array4.map((element, index)=> {
       // console.log(element);
      // let finishText;
      // finishText = <p className='text-main' key={index}>{element}</p>;


      const text1 = element.replace(/{([^}]+)}/gm, '<span class="text-bold">$1</span>');// text in {..} - bold
      const text2 = text1.replace(/@([^@]+)@/gm, '<sup>$1</sup>');// text in @..@ - upper index
      const text3 = text2.replace(/&([^&]+)&/gm, '<sub>$1</sub>');//text in &..& - bottom index
     // console.log(finishText.innerHTML);
 //finishText.dangerouslySetInnerHTML = finishText.dangerouslySetInnerHTML.replace(/{([^}]+)}/gm, '<strong>$1</strong>');
    


            return (
            //finishText 
            
                <p className='text-main' key={index} dangerouslySetInnerHTML={{
                    __html: text3
                }} />
            )

                  //{  /*<p className='text-main' key={index}>{element}</p>*/}
                    
                
                
            }
            )
        )
   

    } else return null;   
}

export {divideText};